import { render, staticRenderFns } from "./btn-list.vue?vue&type=template&id=0436a96a&scoped=true&lang=pug&"
import script from "./btn-list.vue?vue&type=script&lang=coffee&"
export * from "./btn-list.vue?vue&type=script&lang=coffee&"
import style0 from "./btn-list.vue?vue&type=style&index=0&id=0436a96a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0436a96a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BtnQuickShop: require('/opt/build/repo/nuxt-app/components/globals/btn/quick-shop.vue').default,Btn: require('/opt/build/repo/nuxt-app/components/globals/btn/btn.vue').default})
